import colors from './colors';

export {
  colors,
};



/** WEBPACK FOOTER **
 ** ./src/helpers/textEditor/config/index.js
 **/